import * as Sentry from '@sentry/vue'

import { useDevEnvironment } from '@/composables/useDevEnvironment.ts'

const { isDevEnvironment } = useDevEnvironment()

export default {
  error: function (msg: any, exception?: unknown): void {
    const err = exception ?? (msg instanceof Error ? msg : undefined)
    if (err) {
      Sentry.captureException(err, typeof msg === 'string' ? { extra: { msg } } : undefined)
    }

    if (exception) {
      console.error(msg, exception) // eslint-disable-line no-console
    } else {
      console.error(msg) // eslint-disable-line no-console
    }
  },
  warn: function (msg: any): void {
    // Unsere eigenen Warnings erzeugen anders als die restlichen Browser-Warnings keine Sentry Issues und landen deshalb
    // in Production auch nicht in der Console
    if (isDevEnvironment) {
      // eslint-disable-next-line no-console
      console.warn(msg)
    } else {
      Sentry.logger.warn(msg)
    }
  },
  info: function (msg: any): void {
    if (isDevEnvironment) {
      // eslint-disable-next-line no-console
      console.info(msg)
    } else {
      Sentry.logger.info(msg)
    }
  },
  debug: function (msg: any): void {
    if (isDevEnvironment) {
      // eslint-disable-next-line no-console
      console.debug(msg)
    } else {
      Sentry.logger.debug(msg)
    }
  }
}
